import { Plus } from "lucide-react";
import { Button } from "../../../components/Button";
import { Icon } from "../../../components/Icon";
import { Section } from "../DesignSystem";

const row: React.CSSProperties = {
  display: "flex",
  gap: "var(--space-3)",
  flexWrap: "wrap",
  marginBottom: "var(--space-4)",
};

export const ButtonsSection = () => (
  <Section label="05 · Components" title="Buttons">
    <div style={row}>
      <Button variant="primary">Sign in</Button>
      <Button variant="secondary">Stay updated</Button>
      <Button variant="outline">Learn more</Button>
      <Button variant="ghost">About</Button>
      <Button variant="destructive">Delete store</Button>
    </div>
    <div style={row}>
      <Button size="sm" variant="primary">
        Small primary
      </Button>
      <Button size="sm" variant="outline">
        Small outline
      </Button>
    </div>
    <div style={row}>
      <Button leadingIcon={<Icon icon={Plus} />}>Add store</Button>
      <Button variant="outline" trailingIcon={<Icon icon={Plus} />}>
        Add NVR
      </Button>
    </div>
    <div style={row}>
      <Button disabled>Disabled primary</Button>
      <Button variant="outline" disabled>
        Disabled outline
      </Button>
    </div>
  </Section>
);
